import { Suspense, lazy } from 'react';
import CopyTradeSection from '@/components/CopyTradeSection';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import ErrorBoundary from '@/components/ErrorBoundary';
import SEOHelmet from '@/components/SEOHelmet';
import StructuredDataDuocore from '@/components/StructuredDataDuocore';

// Lazy load components for better performance
const DuocoreTeachersSection = lazy(() => import('@/components/DuocoreTeachersSection'));
const DuocoreFAQSection = lazy(() => import('@/components/DuocoreFAQSection'));

const Duocore = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHelmet />
      <StructuredDataDuocore />
      <Header />
      <main>
        <CopyTradeSection />
        <ErrorBoundary>
          <Suspense fallback={<div className="py-20 text-center text-white">Carregando...</div>}>
            <DuocoreTeachersSection />
          </Suspense>
        </ErrorBoundary>
        <ErrorBoundary>
          <Suspense fallback={<div className="py-20 text-center text-white">Carregando...</div>}>
            <DuocoreFAQSection />
          </Suspense>
        </ErrorBoundary>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Duocore;